import React, {
  ChangeEvent,
  KeyboardEvent,
  SyntheticEvent,
  useEffect,
  useState,
} from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { api } from "../../api/api";
import { ROLE_LABELS, User } from "../../types";
import { Box, Button } from "@mui/material";
import CreateModal from "./CreateModal";
import dayjs from "dayjs";
import TableDateFormatter from "../../helpers/TableDateFormatter";

type Props = {};

const Users = (props: Props) => {
  const [rows, setRows] = useState<User[]>([]);
  const [modalConfig, setModalConfig] = useState<{
    data?: User;
    open: boolean;
  }>();
  const [total, setTotal] = useState();

 
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [sortModel, setSortModel] = useState<any>([]);
  const [search, setSearch] = useState("");

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };


  

  const fetcher = async () => {

    const token = localStorage.getItem("token");
  if (!token) {
    console.error("No token found. Unable to fetch data.");
    return;
  }
    api
      .get(
        //@ts-ignore
        `/users?limit=${paginationModel.pageSize}&page=${paginationModel.page}${
          sortModel && sortModel.length > 0
            ? `&sortOrder=${sortModel[0].sort}&sortField=${sortModel[0].field}`
            : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then((res) => {
        console.log(res.data.count)
        setTotal(res.data.count);
        setRows(res.data.users);
      });
  };
  useEffect(() => {
    fetcher();
  }, [paginationModel, sortModel, search]);

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 30 },
    {
      field: "full_name",
      headerName: "Full Name",
      width: 100,
      renderCell: ({ row, value }) => (
        <>
          {row.first_name} {row.last_name}
        </>
      ),
    },
    { field: "email", headerName: "Email", width: 150 },
    { field: "username", headerName: "Username", width: 100 },
    {
      field: "role",
      headerName: "Role",
      width: 100,
      renderCell: ({ value }) => <>{ROLE_LABELS[value] ?? value}</>,
    },

    { field: "phone", headerName: "Phone", width: 80 },
    { field: "max_bookings", headerName: "Max bookings per slot", width: 80 },
    {
      field: "created_at",
      headerName: "Created at",
      width: 150,
      renderCell: ({ row, value }) => <TableDateFormatter date={value} />,
    },
    {
      field: "updated_at",
      headerName: "Updated at",
      width: 150,
      renderCell: ({ row, value }) => <TableDateFormatter date={value} />,
    },
    {
      field: "deleted_at",
      headerName: "Archived at",
      width: 150,
      renderCell: ({ row, value }) => {
        return value ? <TableDateFormatter date={value} /> : "-";
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: ({ row, value }) =>
        row.deleted_at ? "Deactivated" : "Active",
    },
    {
      field: "actions",
      headerName: "",
      width: 200,
      renderCell: (row) => {
        return (
          <Box>
            <Button
              variant="contained"
              color="error"
              sx={{ mr: "10px" }}
              onClick={() => {
                api.delete(`/users/${row.id}`).then((res) => {
                  fetcher();
                });
              }}
            >
              Delete
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => setModalConfig({ data: row.row, open: true })}
            >
              Edit
            </Button>
          </Box>
        );
      },
    },
  ];

  const handleClose = () => {
    setModalConfig((prev) => {
      return { data: undefined, open: false };
    });
  };

  return (
    <>
      <Button onClick={() => setModalConfig({ open: true })}>
        Create User
      </Button>
      <div className="input_wrapper">
        <input placeholder="Search..." onKeyUp={handleSearch} />
      </div>
      <DataGrid
        rows={rows}
        columns={columns}
        onPaginationModelChange={setPaginationModel}
        rowCount={total}
        paginationModel={paginationModel}
        onSortModelChange={setSortModel}
        pageSizeOptions={[5, 10]}
        sx={{ border: 0, height: "86%" }}
        pagination
        sortingMode="server"
        paginationMode="server"
      />

      {modalConfig?.open && modalConfig && (
        <CreateModal
          modalConfig={modalConfig as any}
          handleClose={handleClose}
          fetcher={fetcher}
          setModalConfig={setModalConfig}
        />
      )}
    </>
  );
};

export default Users;
